var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "inline-prompt",
    {
      staticStyle: { "font-size": "0.8rem" },
      attrs: {
        "action-type": "delete",
        placement: "top",
        "action-text": _vm.$t("lists.messages.areYouSureYouWantToUnsubscribe"),
        "confirmation-text": _vm.subscribeConfirmText,
      },
      on: { accept: _vm.handleSubscribe },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "b-tooltip",
              rawName: "v-b-tooltip",
              value: { title: _vm.disabledTooltipText, placement: "top" },
              expression: "{ title: disabledTooltipText, placement: 'top' }",
            },
          ],
          staticClass: "marketing-badge-wrapper",
          on: { click: _vm.handleClick },
        },
        [
          _c(
            "div",
            { class: _vm.isSubscribedDisabled ? "disabled" : "" },
            [
              _c(
                "simple-button",
                {
                  key: _vm.localSubscribed,
                  attrs: {
                    "class-name": "px-2 py-1 btn-sm",
                    loading: _vm.loading,
                    disabled: _vm.isSubscribedDisabled,
                  },
                  on: { finish: _vm.handleButtonFinish },
                },
                [_vm._v("\n        " + _vm._s(_vm.subscribedText) + "\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }